import React from 'react'
import { makeSelectTopic, SUBJECT_TOPICS } from '../../../redux/modules/topic'
import { connect } from 'react-redux'
import { toJS } from '../../../util/ToJS'
import GroupTopic from '../components/GroupTopic'
import VisibleLeafTopic from './VisibleLeafTopic'
import VisibleTopicProblemPage from './VisibleTopicProblemPage'
import LoadingSpinner from '../../../core/components/loading-spinner/LoadingSpinner'
import {withRouter} from 'react-router'

const TopicBodyComponent = ({ isFetching, topic, isSubjectTopic, searchQuery, match }) => {
  const topicIdOrSlug = match.params.topicIdOrSlug
  const topicId = topicIdOrSlug
    .toString()
    .split('-')
    .pop()
  if (isFetching || topic.id.toString() !== topicId) {
    // @TODO: topic object and match param get out of sync somehow.
    // This is a bandaid solution to prevent it from totally failing.
    return <LoadingSpinner />
  }
  if (topic.isLeaf) {
    if (searchQuery.type === 'problem' && searchQuery.id) {
      return <VisibleTopicProblemPage topic={topic} problemId={searchQuery.id} />
    } else {
      return <VisibleLeafTopic topic={topic} explanationId={searchQuery.id} />
    }

  } else {
    let topAncestor = topic
    // leaf breadcrumbs don't have access to top ancestor for some reason
    while (topAncestor.depth > 2) {
      topAncestor = topAncestor.parent
    }
    return (
      <GroupTopic
        topAncestor={topAncestor}
        leaves={topic.leaves}
        children={topic.children}
        isSubjectTopic={isSubjectTopic}
      />
    )
  }
}

const makeMapStateToProps = () => {
  const selectTopic = makeSelectTopic()
  const mapStateToProps = state => {
    const topic = selectTopic(state)
    return {
      topic,
      isSubjectTopic: SUBJECT_TOPICS.has(topic.get('id')),
      isFetching: state.getIn(['topic', 'isFetching'])
    }
  }
  return mapStateToProps
}
const TopicBody = withRouter(connect(makeMapStateToProps)(toJS(TopicBodyComponent)))

export default TopicBody



// WEBPACK FOOTER //
// ./src/domains/topic/containers/TopicBody.js